<script>
import DatePicker from "vue2-datepicker";
import { TicketsPath } from "../../../../../path";
import axios from "axios";
import moment from "moment";
export default {
  props: ["ticket"],
  components: { DatePicker },
  data() {
    return {
      change_tat: "",
      base_url: process.env.VUE_APP_API_BACKEND_URL,
    };
  },
  methods: {
    async changeTat() {
      console.log(this.ticket, "id");
      console.log(moment(this.change_tat).format("YYYY-MM-DD H"));
      try {
        let res = await axios.post(
          this.base_url + TicketsPath.UPDATE_TICKET_TAT,
          {
            date_time: moment(this.change_tat).format("YYYY-MM-DD H"),
            id: this.ticket.id,
          }
        );

        if (res.data.status) {
          console.log(res.data.data);
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<template>
  <b-card>
    <b-row>
      <b-col sm="12">
        <date-picker
          ref="datePicker"
          v-model="change_tat"
          type="datetime"
        ></date-picker>
      </b-col>
      <b-col style="margin-top: 10px">
        <b-button variant="success" @click="changeTat"> Save </b-button>
      </b-col>
    </b-row>
  </b-card>
</template>

<style></style>
